import { softwareDevelopmentOutsourcing } from './software-development-outsourcing';
import { aiSoftwareDevelopmentConsulting } from './ai-software-development-consulting';
import { uxUiDesignConsultingServices } from './ux-ui-design-consulting-services';
import { home } from './home';
import { clients } from './clients';
import { about } from './about';
import { career } from './career';
import { contact } from './contact';
import { work } from './work';
import { developmentTeams } from './development-teams';
import { productDesignAndDevelopment } from './product-design-and-development';
import { categoryPage } from './category-page';
import { newsroom } from './newsroom';
import { agileProductBuilders } from './agile-product-builders';
import { apbCommunityNewsletter } from './apb-community-newsletter';
import { boldGrowthMeetup } from './bold-growth-meetup';
import { bookDiscoverySession } from './book-a-discovery-session';
import { bringQualifiedLead } from './bring-a-qualified-lead';
import { CtoAsks } from './CTO-asks';
import { cookiesPolicy } from './cookies-policy';
import { digitaleTransformation } from './digitale-transformation';
import { forShareholders } from './for-shareholders';
import { gitex2019 } from './gitex-2019';
import { hackTheWind } from './hack-the-wind';
import { practicalAiApplication } from './practical-ai-application';
import { privacyPolicy } from './privacy-policy';
import { renewableEnergyIndustry } from './renewable-energy-industry';
import { rescueFailingProject } from './rescue-failing-project';
import { scaleYourAiSolutionMeetup } from './scale-your-AI-solution-meetup';
import { serviceStandards } from './service-standards';
import { services } from './services';
import { softwareDevelopmentDesignSaudiArabia } from './software-development-design-saudi-arabia';
import { sprintRetrospectiveTool } from './sprint-retrospective-tool';
import { transformGapsIntoOpportunitiesWorkshop } from './transform-gaps-into-opportunities-workshop';
import { whenToInvestInUxWebinar } from './when-to-invest-in-ux-webinar';
import { defaultMarkup } from './defaultMarkup';

export const markup = {
  softwareDevelopmentOutsourcing,
  aiSoftwareDevelopmentConsulting,
  uxUiDesignConsultingServices,
  home,
  clients,
  about,
  career,
  contact,
  work,
  developmentTeams,
  productDesignAndDevelopment,
  categoryPage,
  newsroom,
  agileProductBuilders,
  apbCommunityNewsletter,
  boldGrowthMeetup,
  bookDiscoverySession,
  bringQualifiedLead,
  CtoAsks,
  cookiesPolicy,
  digitaleTransformation,
  forShareholders,
  gitex2019,
  hackTheWind,
  practicalAiApplication,
  privacyPolicy,
  renewableEnergyIndustry,
  rescueFailingProject,
  scaleYourAiSolutionMeetup,
  serviceStandards,
  services,
  softwareDevelopmentDesignSaudiArabia,
  sprintRetrospectiveTool,
  transformGapsIntoOpportunitiesWorkshop,
  whenToInvestInUxWebinar,
  defaultMarkup,
};
